<template>
  <transition name="mask">
    <div v-if="data" class="s-modal-mask"></div>
  </transition>
</template>
<script>
export default {
  name: 'z-mask',
  props: {
    data: null
  },
  watch: {
    data() {
      // 遮罩层出现 禁止底层滚动
      if (this.data) {
        document
          .querySelector('body')
          .setAttribute('style', 'overflow: hidden;')
      } else {
        document.querySelector('body').setAttribute('style', '')
      }
    }
  },
  methods: {}
}
</script>
<style lang="scss" scoped>
.mask-enter-active,
.mask-leave-active {
  transition: opacity 0.35s;
  -moz-transition: opacity 0.35s;
  /* Firefox 4 */
  -webkit-transition: opacity 0.35s;
  /* Safari 和 Chrome */
  -o-transition: opacity 0.35s;
  /* Opera */
}

.mask-enter,
.mask-leave-to {
  opacity: 0;
}

.s-modal-mask {
  cursor: pointer;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(55, 55, 55, 0.6);
  height: 100%;
  z-index: 100;
}
</style>
